import { useEffect, useState } from 'react'
import type { EditorMode } from '@/msgdeskRuntime/contracts/editorActions'
import { treeStore, type EditorAttachmentState } from '@/msgdeskRuntime/state'

export function useEditorAttachments() {
  const [attachments, setAttachments] = useState<EditorAttachmentState[]>(
    () => treeStore.getState().templateData.editorAttachments || [],
  )

  useEffect(() => treeStore.subscribe(() => {
    const next = treeStore.getState().templateData.editorAttachments || []
    setAttachments(current => current === next ? current : next)
  }), [])

  return attachments
}

export function visibleEditorAttachments(
  attachments: EditorAttachmentState[],
  editorMode?: EditorMode,
  options: { includeAvatar?: boolean } = {},
) {
  const visible = attachments.filter(attachment => (
    !attachment.isUploadPlaceholder && (options.includeAvatar || !attachment.isAvatar)
  ))
  if (editorMode === 'update_msg') return visible
  return visible.filter(attachment => String(attachment.src || '').startsWith('blob:'))
}
